import { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS,
} from "../Redux/Constants/userContants";

export function useLoading() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: USER_LOGIN_REQUEST });

        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/user/refresh`,
          {
            withCredentials: true,
          }
        );
        console.log(data);
        if (data && data.role === "user")
          dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
        else if (data && data.role === "seller") console.log(data);
        dispatch({
          type: CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS,
          payload: data,
        });

        setLoading(false);
      } catch (error) {
        dispatch({
          type: USER_LOGIN_FAIL,
          payload: error.response.data.message,
        });
        console.log(error.response.data.message);
        setLoading(false);
      }
    })();
  }, []);

  return { loading };
}
